import { render, staticRenderFns } from "./MyHealthPage.vue?vue&type=template&id=c131f456&scoped=true&"
import script from "./MyHealthPage.vue?vue&type=script&lang=ts&"
export * from "./MyHealthPage.vue?vue&type=script&lang=ts&"
import style0 from "./MyHealthPage.vue?vue&type=style&index=0&id=c131f456&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c131f456",
  null
  
)

export default component.exports